/**
 * Generates a unique ID string
 * @param prefix - Optional prefix for the ID
 * @returns A unique identifier string
 *
 * @example
 * ```ts
 * generateId() // => "x7k2m9p3q"
 * generateId('tooltip') // => "tooltip-x7k2m9p3q"
 * ```
 */
export const generateId = (prefix?: string): string => {
	const id = Math.random().toString(36).slice(2, 11);
	return prefix ? `${prefix}-${id}` : id;
};
